import { render } from "./examPaperView.vue?vue&type=template&id=46e4c203&scoped=true"
import script from "./examPaperView.vue?vue&type=script&lang=js"
export * from "./examPaperView.vue?vue&type=script&lang=js"

import "./examPaperView.vue?vue&type=style&index=0&id=46e4c203&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46e4c203"]])

export default __exports__